// extracted by mini-css-extract-plugin
export default {"SectionText":"SectionText__SectionText__bEaaZ"};